<template>
  <div
    class="empty">
    <img
      :src="monsterImage()"
      :srcset="monsterImage('set')"
      class="empty-img"
      alt="Empy Library"
      data-test="empty-library">
    <p
      class="empty-msg">
      You haven't saved any {{ (option === 'shows' || option === 'podcast-episodes') ? 'shows ' : 'episodes ' }} yet
    </p>
    <router-link
      data-test="btn-startListening"
      class="el-button btn-transparent"
      to="/listen">Start Listening</router-link>
  </div>
</template>
<script>
import playlistMonster1x from '../assets/images/art_monster_playlist_1x.png';
import playlistMonster2x from '../assets/images/art_monster_playlist_2x.png';
import playlistMonster3x from '../assets/images/art_monster_playlist_3x.png';
import showsMonster1x from '../assets/images/art_monster_shows_1x.png';
import showsMonster2x from '../assets/images/art_monster_shows_2x.png';
import showsMonster3x from '../assets/images/art_monster_shows_3x.png';
import podcastMonster1x from '../assets/images/art_monster_episodes_1x.png';
import podcastMonster2x from '../assets/images/art_monster_episodes_2x.png';
import podcastMonster3x from '../assets/images/art_monster_episodes_3x.png';

export default {
  name: 'EmptyShows',
  props: {
    // Can accept 'shows' ,'podcasts-episodes' , 'playlist'
    option: {
      type: String,
      default: '',
    },
  },
  methods: {
    monsterImage(set) {
      const options = {
        shows: [showsMonster1x, showsMonster2x, showsMonster3x],
        'podcast-episodes': [podcastMonster1x, podcastMonster2x, podcastMonster3x],
        playlist: [playlistMonster1x, playlistMonster2x, playlistMonster3x],
      };
      if (set) {
        return this.srcSet('srcset', options[this.option]);
      }
      return this.srcSet('src', options[this.option]) || '';
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/variables";
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-wrap: wrap !important;
  .empty-msg {
    display: block;
    width: 100%;
    margin: 15px 0;
    text-align: center;
  }
}
@media (max-width: 576px) {
  .empty {
    .empty-img {
      max-width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/EmptyShows.vue